'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind from "./presto.types$-Grouping-Kind.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingKind$$anon$16(_$ordinal$22, \u03b4name$22, outer) {
  this.aab = 0;
  this.aaa = null;
  this.aab = _$ordinal$22;
  this.aaa = \u03b4name$22;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$GroupingKind$$anon$16 as $c_Lpresto_types$GroupingKind$$anon$16 };
$p = $c_Lpresto_types$GroupingKind$$anon$16.prototype = new $j_presto$002etypes$0024$002dGrouping$002dKind.$h_Lpresto_types$GroupingKind();
$p.constructor = $c_Lpresto_types$GroupingKind$$anon$16;
/** @constructor */
function $h_Lpresto_types$GroupingKind$$anon$16() {
}
export { $h_Lpresto_types$GroupingKind$$anon$16 as $h_Lpresto_types$GroupingKind$$anon$16 };
$h_Lpresto_types$GroupingKind$$anon$16.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.aaa;
});
$p.l = (function() {
  return this.aaa;
});
var $d_Lpresto_types$GroupingKind$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingKind$$anon$16, "presto.types$GroupingKind$$anon$16", ({
  a0t: 1,
  jY: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$GroupingKind$$anon$16 as $d_Lpresto_types$GroupingKind$$anon$16 };
//# sourceMappingURL=presto.types$-Grouping-Kind$$anon$16.js.map
